import { render, staticRenderFns } from "./vue-load.vue?vue&type=template&id=00f3138a&scoped=true&"
import script from "./vue-load.vue?vue&type=script&lang=js&"
export * from "./vue-load.vue?vue&type=script&lang=js&"
import style0 from "./vue-load.vue?vue&type=style&index=0&id=00f3138a&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f3138a",
  null
  
)

export default component.exports